import PieChart from "../../../../../components/pieChart/pieChart";
import { connect } from "react-redux";

export default connect(state => ({
  showPercent: true,
  data: state.membershipBreakdown.membershipsPieChartValues,
  isClubPilates: state.membershipBreakdown.currentUser.params.organization_name === "Club Pilates",
  showLegend: true,
  legendPosition: "right"
}))(PieChart);
